"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const MyResultsIcon = createIcon({
  displayName: "MyResultsIcon",
  viewBox: "0 0 40.54 45",
  path: (
    <>
      <path
        d="M31.53,18.09L40.54,0h-15.77l-4.5,9.01L15.77,0H0l9.08,18.2.92,1.85c-1.67,1.64-2.95,3.69-3.67,5.99-.43,1.37-.65,2.84-.65,4.37,0,8.06,6.53,14.59,14.59,14.59,2.03,0,3.94-.41,5.68-1.15.45-.18.88-.38,1.28-.61,4.55-2.48,7.64-7.3,7.64-12.84,0-4.05-1.64-7.73-4.32-10.36l.99-1.96ZM27.45,37.59c-1.98,1.96-4.37,2.95-7.18,2.95s-5.2-.99-7.18-2.95c-1.96-1.98-2.95-4.37-2.95-7.18s.99-5.2,2.95-7.18c1.98-1.96,4.37-2.95,7.18-2.95s5.2.99,7.18,2.95c1.96,1.98,2.95,4.37,2.95,7.18s-.99,5.2-2.95,7.18ZM27.59,4.5h5.7l-6.42,12.84c-.5-.27-.99-.47-1.46-.65-.5-.16-1.01-.32-1.53-.47l-1.06-2.14,4.77-9.57ZM7.32,4.5h5.63l5.7,11.37c-.88.07-1.73.25-2.57.47-.86.25-1.64.59-2.39.99L7.32,4.5Z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default MyResultsIcon;
